import { Add, Download } from "@mui/icons-material";
import { Alert, Button, Grid, LinearProgress, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { CSVLink } from "react-csv";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import defaultColDef from "../../constants/defaultColDef";
import Wahlname from "../../interface/Wahlname";
import { getWahlen } from "../../services/api.service";

function ElectionNameDashboard(): JSX.Element {
    const navigate = useNavigate();

    const { data, error, isLoading } = useQuery<Wahlname[]>(["wahlen"], async () => await getWahlen());

    if (error) return <Alert severity="error">Error Loading</Alert>;
    if (isLoading) return <LinearProgress />;

    if (data) {
        return (
            <Grid container p={2} spacing={2}>
                <Grid item xs={12} md={8}>
                    <Typography variant={"h5"}>Wahlen</Typography>
                </Grid>
                <Grid item xs={12} md={4} display="flex" justifyContent="end">
                    <CSVLink
                        data={data}
                        filename={`wahlen.csv`}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Button variant="contained" startIcon={<Download />}>CSV Export</Button>
                    </CSVLink>
                    <Button sx={{ ml: 1 }} variant="contained" onClick={() => navigate(`/wahlen/create`)}><Add /></Button>
                </Grid>
                <Grid item xs={12}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "70vh" }}>
                        <AgGridReact
                            rowData={data}
                            defaultColDef={defaultColDef}
                            columnDefs={[
                                { field: 'wahlname' },
                            ]}
                        />
                    </div>
                </Grid>
            </Grid>
        );
    }
    return <></>;
}

export default ElectionNameDashboard;